import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { ArrowRight, Calendar, User, FileText } from 'lucide-react';
import { blogService } from '../services/db';

const BlogList = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const fetchedPosts = await blogService.getPosts();
                setPosts(fetchedPosts);
            } catch (err) {
                console.error("Failed to fetch blog posts:", err);
                setError("No se pudieron cargar las publicaciones.");
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return (
        <Layout>
            <div className="max-w-7xl mx-auto">
                <div className="mb-12 text-center">
                    <h2 className="text-4xl font-display font-bold text-white mb-4">Blog & Análisis</h2>
                    <p className="text-zinc-400 max-w-2xl mx-auto">
                        Investigaciones profundas, actualizaciones de la auditoría y noticias sobre transparencia.
                    </p>
                </div>

                {loading ? (
                    <div className="flex justify-center py-20">
                        <span className="loading loading-spinner loading-lg text-primary">Cargando...</span>
                    </div>
                ) : error ? (
                    <div className="text-center py-20 text-red-400">
                        {error}
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {posts.map((post) => (
                            <div key={post.id} className="group flex flex-col h-full bg-surface border border-zinc-800/50 rounded-xl overflow-hidden hover:border-primary/50 transition-all duration-300">
                                {post.imageUrl ? (
                                    <div className="aspect-video w-full overflow-hidden">
                                        <img
                                            src={post.imageUrl}
                                            alt={post.title}
                                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                        />
                                    </div>
                                ) : (
                                    <div className="aspect-video w-full bg-zinc-900 flex items-center justify-center border-b border-zinc-800">
                                        <FileText className="w-12 h-12 text-zinc-700" />
                                    </div>
                                )}

                                <div className="flex flex-col flex-1 p-6">
                                    <div className="flex items-center gap-4 text-xs text-zinc-500 font-mono mb-3">
                                        {post.publishedAt && (
                                            <span className="flex items-center gap-1">
                                                <Calendar className="w-3 h-3" />
                                                {new Date(post.publishedAt).toLocaleDateString()}
                                            </span>
                                        )}
                                        {post.author && (
                                            <span className="flex items-center gap-1">
                                                <User className="w-3 h-3" />
                                                {post.author}
                                            </span>
                                        )}
                                    </div>

                                    <h3 className="text-xl font-bold font-display text-white mb-2 group-hover:text-primary transition-colors">
                                        {post.title}
                                    </h3>

                                    {post.excerpt && (
                                        <p className="text-zinc-400 text-sm mb-4 line-clamp-3">
                                            {post.excerpt}
                                        </p>
                                    )}

                                    <div className="mt-auto pt-4">
                                        <Link
                                            to={`/blog/${post.slug}`}
                                            className="inline-flex items-center text-sm font-medium text-primary hover:text-primary-dim transition-colors"
                                        >
                                            Leer artículo <ArrowRight className="w-4 h-4 ml-2" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {!loading && posts.length === 0 && !error && (
                    <div className="text-center py-20 text-zinc-500">
                        No hay publicaciones disponibles por el momento.
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default BlogList;
